import { faWarning } from "@fortawesome/pro-regular-svg-icons";

import { TableColumn } from "@/components/Table/Table";

import { LeadStatusCell } from "./LeadStatusCell";
import { ListPerson } from "../schema/list";

/**
 * Left-locked status indicator ("maybe" column). The per-row decision — warning, scoring in
 * progress, score pill or inclusion dot — lives in `LeadStatusCell`, which needs to be a component
 * rather than a render callback because it subscribes to the pending-scoring query (PREC-4076).
 * `ts` scopes to the `inbox.` keys.
 */
export const renderMaybeColumn = (ts?: (key: string) => string): TableColumn => {
	return {
		title: "",
		icon: faWarning,
		width: "fit-content",
		allowExclude: false,
		uid: "blacklist",
		locked: "leftSecond",
		hideable: false,
		moveable: false,
		calcWidth: 40,
		show: true,
		render: (row: ListPerson) => <LeadStatusCell row={row} ts={ts} />,
	};
};
